/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpsertTaskTemplateRequest} from '@cash-web/protos/squareup/stafftasks/endpoints/upsert-task-template.pb'
import {UpsertTaskTemplateResponse} from '@cash-web/protos/squareup/stafftasks/endpoints/upsert-task-template.pb'


export const upsertTaskTemplate = (request: UpsertTaskTemplateRequest, options?: CashRequestOptions) => post<UpsertTaskTemplateRequest, UpsertTaskTemplateResponse>("/proxy/services/squareup.stafftasks.service.StaffTasksService/UpsertTaskTemplate", request, {...options, rejectOnError: true })